<template>
  <div class="mainContent">
    <img :src="image[$i18n.locale]" />
    <a class="signIn" @click="doLogin"></a>
    <a class="signUp" @click="doRegister"></a>
    <div v-if="$i18n.locale === 'en'">
      <a class="tipA_en" @click="doUser"></a>
      <a class="tipQ_en" @click="doIntegral"></a>
    </div>
    <div v-if="$i18n.locale === 'zh'">
      <a class="tipA_zh" @click="doUser"></a>
      <a class="tipQ_zn" @click="doIntegral"></a>
    </div>

  </div>
</template>

<script>
const imageZh = require('@/assets/image/other/club-zh.jpg');
const imageEn = require('@/assets/image/other/club-en.jpg');

export default {
  name: 'club',
  data() {
    return {
      image: {
        zh: imageZh,
        en: imageEn,
      },
    };
  },
  methods: {
    doLogin() {
      this.$parent.openLoginModal();
    },
    doRegister() {
      this.$router.push('/register');
    },
    doIntegral() {
      this.$router.push('/info-footer/stock');
    },
    doUser() {
      this.$router.push('/info-footer/agreen');
    },
  },
};
</script>
<style lang="sass" scoped>
@import '../../assets/css/mixins'

.mainContent
  min-height: 300px
  @include base-wrap
  overflow: hidden
  border: 13px solid #f5eccf
  margin-bottom: 10px

</style>
<style scoped lang="scss">
.mainContent {
  position: relative;
  padding-left: 23px;
  a {
    position: absolute;
    display: inline-block;

    &.signIn {
      bottom: 170px;
      left: 130px;
      width: 210px;
      height: 60px;
    }
    &.signUp {
      bottom: 170px;
      left: 565px;
      width: 210px;
      height: 60px;
    }
    &.tipA_en {
      width: 190px;
      height: 21px;
      bottom: 60px;
      left: 80px;
    }
    &.tipQ_en {
      width: 320px;
      height: 21px;
      bottom: 60px;
      left: 290px;
    }
    &.tipA_zh {
      width: 120px;
      height: 21px;
      bottom: 43px;
      left: 80px;
    }
    &.tipQ_zn {
      width: 120px;
      height: 21px;
      bottom: 43px;
      left: 210px;
    }
  }
  img {
    width: 100%;
  }
}
</style>
